
export enum EventModule {
	Cart = 'Carrito'
}

export enum CartEventCode {
	ProductsAdded = 'ProductsAdded',
	ProductsConfirmed = 'ProductsConfirmed',
	CheckoutConfirmed = 'CheckoutConfirmed',
	PaymentConfirmed = 'PaymentConfirmed'
}
